import { TFunction } from 'i18next'

export const AUDIT_OPERATIONS = {
  update: 'update',
  delete: 'delete',
  insert: 'insert',
} as const

type AuditOperation = typeof AUDIT_OPERATIONS[keyof typeof AUDIT_OPERATIONS]

export default function translateOperation({ operation, t }: { operation: string; t: TFunction }) {
  if ((operation as AuditOperation) in AUDIT_OPERATIONS) {
    return t(`pms.audits.grid.operation.${operation}`)
  }

  return operation
}
